<template>
  <vs-row
    id="holidays-table"
    vs-w="12"
    class="flex-no-wrap gap-1"
    ref="holidaysTable"
  >
    <!-- 休日日数 -->
    <vs-col
      vs-type="flex"
      vs-justify="flex-start"
      vs-align="center"
      vs-lg="3"
      vs-sm="3"
      vs-xs="12"
      class="flex-col"
    >
      <div><span class="aisea-text-14-700-black">休日日数</span></div>
      <div class="aisea-text-12-400-black">
        (<span class="aisea-text-12-400-blue">付与</span>/<span>必要</span>)
      </div>
    </vs-col>
    <!-- 休日 -->
    <vs-col
      vs-type="flex"
      vs-justify="flex-start"
      vs-align="center"
      vs-lg="3"
      vs-sm="3"
      vs-xs="12"
      class="flex-col gap-px text-center"
    >
      <div class="holiday-table-header flex-col w-full"><span>休日</span></div>
      <div class="holiday-table-body flex gap-px w-full justify-center">
        <span class="aisea-text-12-400-blue">{{ numOfGrantedHoliays }}</span
        >/<span class="aisea-text-12-400-black">{{
          numOfRequiredHoliaysDisp
        }}</span>
      </div>
    </vs-col>

    <!-- 補償休日 -->
    <vs-col
      vs-type="flex"
      vs-justify="flex-start"
      vs-align="center"
      vs-lg="3"
      vs-sm="3"
      vs-xs="12"
      class="flex-col gap-px text-center"
    >
      <div class="holiday-table-header flex-col w-full">
        <span>補償休日</span>
      </div>
      <div class="holiday-table-body flex gap-px w-full justify-center">
        <span class="aisea-text-12-400-blue">
          {{ numOfGrantedCompensationHoliays }} </span
        >/<span class="aisea-text-12-400-black">
          {{ numOfRequiredCompensationHoliaysDisp }}
        </span>
      </div>
    </vs-col>

    <!-- 有給休暇 -->
    <vs-col
      vs-type="flex"
      vs-justify="flex-start"
      vs-align="center"
      vs-lg="3"
      vs-sm="3"
      vs-xs="12"
      class="flex-col gap-px text-center"
    >
      <div class="holiday-table-header flex-col w-full">
        <span>有給休暇</span>
      </div>
      <div class="holiday-table-body flex gap-px w-full justify-center">
        <span class="aisea-text-12-400-blue">
          {{ numOfGrantedPaidHoliays }} </span
        >/<span class="aisea-text-12-400-black">
          {{ numOfRequiredPaidHoliaysDisp }}
        </span>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: "HolidaysTable",
  mixins: [],
  components: {},
  props: {
    numOfRequiredHoliays: { Type: Number, default: 0 },
    numOfGrantedHoliays: { Type: Number, default: null },
    numOfRequiredCompensationHoliays: { Type: Number, default: 0 },
    numOfGrantedCompensationHoliays: { Type: Number, default: null },
    numOfRequiredPaidHoliays: { Type: Number, default: 0 },
    numOfGrantedPaidHoliays: { Type: Number, default: null },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    numOfRequiredHoliaysDisp() {
      return this.numOfRequiredHoliays || 0;
    },
    numOfRequiredCompensationHoliaysDisp() {
      return this.numOfRequiredCompensationHoliays || 0;
    },
    numOfRequiredPaidHoliaysDisp() {
      return this.numOfRequiredPaidHoliays || 0;
    },
  },
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#holidays-table {
  display: flex;
  min-width: 320px;
  .holiday-table-header {
    background-color: $aisea-gray;
    > span {
      color: $aisea-white;
    }
  }
  .holiday-table-body {
    background-color: #e0e0e0;
  }
}
</style>
